<div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
</div>
<div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden tw-bg-gray-100">
  <div class="tw-flex-none tw-bg-grid-layout tw-bg-yellow-100 tw-pt-20 tw-pb-[60px]">
    <div class="tw-font-body tw-font-bold tw-text-600 tw-tracking-normal tw-text-center" i18n="@@myOrders">My orders</div>
  </div>
  <div class="tw-flex-none tw-flex tw-px-6 tw-gap-2 tw-relative tw-z-10 tw-mt-[-20px]">
    <div class="tw-h-10 tw-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full" [ngClass]="{'tw-bg-white tw-shadow-z1': activeOrderType !== orderType.active, 'tw-bg-black tw-text-white': activeOrderType === orderType.active }" (click)="changeOrderType(orderType.active)">
      <span i18n="@@active">active</span>
    </div>
    <div class="tw-h-10 tw-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full" [ngClass]="{'tw-bg-white tw-shadow-z1': activeOrderType !== orderType.completed, 'tw-bg-black tw-text-white': activeOrderType === orderType.completed }" (click)="changeOrderType(orderType.completed)">
      <span i18n="@@completed">completed</span>
    </div>
    <div class="tw-h-10 tw-flex tw-items-center tw-justify-center tw-px-4 tw-rounded-full" [ngClass]="{'tw-bg-white tw-shadow-z1': activeOrderType !== orderType.cancelled, 'tw-bg-black tw-text-white': activeOrderType === orderType.cancelled }" (click)="changeOrderType(orderType.cancelled)">
      <span i18n="@@cancelled">cancelled</span>
    </div>
  </div>
  <div class="tw-flex-auto tw-relative tw-overflow-y-auto">
    @if (isLoading) {
      <loading class="pos-abs vh-center"></loading>
    }
    @if (!isLoading) {
      <div class="tw-flex tw-flex-col tw-gap-3 tw-pt-5 tw-px-5 tw-mb-6">
        @if (!orders?.length) {
          <div class="empty-hint centerA empty-icon">
            <span class="tw-font-body tw-text-300" i18n="@@noOrdersAvailable">No orders available</span>
          </div>
        }
        @for (order of orders; track order) {
          <div routerLink="/user/order/{{order?.id}}">
            @if (order?.get('type') === appConfig.Shared.Order.Type.REGIMEN && (order?.get('regimenStateAtLastCheckpoint')?.get('regimenId') || order?.get('regimen')?.get('regimenId'))) {
              <div class="tw-rounded-3 tw-p-4 tw-border tw-border-gray-200 tw-shadow-z4 tw-bg-white">
                <div class="tw-flex tw-justify-between tw-mb-5">
                  <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
                    @switch (true) {
                      @case (order.get('stage') === 'INITIAL') {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none" i18n="@@orderNotPlacedYet">
                    Order not placed yet
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none">
                          <span i18n="@@orderNumber">Order number</span><span>: {{'#'+order.get('orderNumber')}}</span>
                        </p>
                      }
                    }
                    @switch (true) {
                      @case (orderPaymentPendingStages.includes(order.get('stage'))) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      }
                      @case (!!ordersMap.get(order.id)?.expectedDeliveryDate?.to) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{ordersMap.get(order.id)?.expectedDeliveryDate?.to | date: 'd MMM'}}</span>
                        </p>
                      }
                      @case (!ordersMap.get(order.id)?.expectedDeliveryDate?.to && !orderDeliveredStages.includes(order.get('stage')) && !!order.get('deliverOnDate')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{ order.get('deliverOnDate') | date:'dd MM' }}</span>
                        </p>
                      }
                      @case (!ordersMap.get(order.id)?.expectedDeliveryDate?.to && orderDeliveredStages.includes(order.get('stage')) && !!order.get('deliveredOn')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@deliveredOn">Delivered on</span><span>: {{ order.get('deliveredOn') | date:'dd MMM yyyy' }}</span>
                        </p>
                      }
                      @case (orderCanceledStages.includes(order.get('stage')) && !order.get('canceledByUser')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@placeANewOrder">
                    Place a new order
                  </p>
                      }
                      @case (!isCurrentOrderInRefundStages(order?.id) && orderCanceledStages.includes(order.get('stage')) && !!order.get('canceledByUser')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@userCancelled">
                    User cancelled
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          -
                        </p>
                      }
                    }
                  </div>
                  @switch (true) {
                    @case (orderPaymentPendingStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-yellow-400 tw-bg-yellow-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      </div>
                    }
                    @case (orderPlacedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@orderPlaced">
                    Order placed
                  </p>
                      </div>
                    }
                    @case (orderPackedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@packed">
                    Packed
                  </p>
                      </div>
                    }
                    @case (orderDispatchedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@dispatched">
                    Dispatched
                  </p>
                      </div>
                    }
                    @case (orderOutForDeliveryStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-red-400 tw-bg-red-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@outForDelivery">
                    Out For Delivery
                  </p>
                      </div>
                    }
                    @case (orderDeliveryFailedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@deliveryAttemptFailed">
                    Delivery attempt failed
                  </p>
                      </div>
                    }
                    @case (orderDeliveredStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@delivered">Delivered</p>
                        <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                        </div>
                      </div>
                    }
                    @case (isCurrentOrderInRefundStages(order?.id) && (orderCanceledStages.includes(order.get('stage')) || order.get('stage') === appConfig.Shared.Order.Stage.REFUND_INITIATED)) {
                      <div>
                        @if (refundRelatedStageOrdersMap.get(order?.id)?.stage === appConfig.Shared.Order.Stage.REFUND_REQUESTED) {
                          <p class="tw-font-body tw-text-200 tw-text-gray-500">
                            Refund Requested
                          </p>
                        }
                        @if (refundRelatedStageOrdersMap.get(order?.id)?.stage === appConfig.Shared.Order.Stage.REFUND_INITIATED) {
                          <p class="tw-font-body tw-text-200 tw-text-gray-500">
                            Refund Initiated
                          </p>
                        }
                        @if (refundRelatedStageOrdersMap.get(order?.id)?.stage === appConfig.Shared.Order.Stage.REFUND_PROCESSED) {
                          <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                            <p class="tw-font-body tw-text-200 tw-text-black">
                              Refunded
                            </p>
                            <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                              <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @case (!isCurrentOrderInRefundStages(order?.id) && orderCanceledStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto" i18n="@@canceled">
                    Cancelled
                  </p>
                        <div class="tw-rounded-full tw-bg-red-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'close'"></cs-icon>
                        </div>
                      </div>
                    }
                    @default {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1 tw-bg-gray-100 tw-border tw-border-gray-300 tw-px-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto">
                          {{order.get('stage').replace('_', ' ') | titlecase}}
                        </p>
                      </div>
                    }
                  }
                </div>
                <div class="tw-flex tw-items-center tw-gap-4">
                  <div>
                    <div class="tw-bg-teal-100 tw-w-32 tw-h-[120px] tw-rounded-3">
                      <img [src]="order.get('regimenStateAtLastCheckpoint')?.get('regimenCoverImage') || order.get('regimen')?.get('regimenCoverImage')" class="tw-w-32 tw-h-[120px] tw-object-cover tw-rounded-3" alt="regimen_img"/>
                    </div>
                  </div>
                  <div>
                    <div class="tw-flex tw-flex-col tw-gap-2">
                      @if (order.get('regimenStateAtLastCheckpoint')?.get('displayConcern')?.name || order?.get('regimen')?.get('displayConcern')?.name) {
                        <p class="tw-text-400 tw-font-body tw-font-bold tw-text-black">
                          <span>
                            Treatment <br/> Kit for <br/> {{order.get('regimenStateAtLastCheckpoint')?.get('displayConcern')?.name || order?.get('regimen')?.get('displayConcern')?.name}}
                          </span>
                        </p>
                      }
                      @if (!(order.get('regimenStateAtLastCheckpoint')?.get('displayConcern')?.name || order?.get('regimen')?.get('displayConcern')?.name)) {
                        <p class="tw-text-400 tw-font-body tw-font-bold tw-text-black">
                          @if (order.get('regimenStateAtLastCheckpoint')?.get('class') === appConfig.Shared.InstantCheckup.Type.FACE || order.get('regimen')?.get('class') === appConfig.Shared.InstantCheckup.Type.FACE) {
                            <span>
                              Treatment <br/> Kit for <span class="tw-capitalize">{{appConfig.Shared.RegimenFor.SKIN.toLowerCase()}} </span>
                            </span>
                          }
                          @if ((order.get('regimenStateAtLastCheckpoint')?.get('class') && order.get('regimenStateAtLastCheckpoint')?.get('class') !== appConfig.Shared.InstantCheckup.Type.FACE) || order.get('regimen').get('class') !== appConfig.Shared.InstantCheckup.Type.FACE) {
                            <span>
                              Treatment <br/> Kit for <span class="tw-capitalize">{{order.get('regimenStateAtLastCheckpoint')?.get('class')?.toLowerCase() || order.get('regimen').get('class').toLowerCase()}} </span>
                            </span>
                          }
                        </p>
                      }
                    </div>
                    @if (getFreeProductDetails(order)) {
                      <div class="tw-mt-2">
                        <p class="tw-text-200 tw-font-body tw-text-gray-800"> + Free Pouch </p>
                      </div>
                    }
                  </div>
                </div>
                @switch (true) {
                  @case (orderPaymentPendingStages.includes(order.get('stage'))) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <span class="tw-w-max tw-max-w-[90%] tw-bg-teal-600 tw-text-white tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden tw-capitalize tw-py-2 tw-px-4" i18n="@@makePayment"> Make payment </span>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.get('stage')) && order.get('paymentType') === 'COD') {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <div class="tw-flex tw-flex-col">
                        <p class="tw-font-body tw-text-300">
                          <span class="tw-text-black" i18n="@@amountToBePaid">Amount to be paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                        </p>
                        @if (order.get('paymentType') === 'COD') {
                          <p class="tw-font-body tw-text-300">
                            (Cash on delivery)
                          </p>
                        }
                      </div>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.get('stage')) && order.get('paymentType') !== 'COD') {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (orderDeliveredStages.includes(order.get('stage'))) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @default {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@orderAmount">Order amount</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order?.get('regimenStateAtLastCheckpoint')?.get('fixedPrice') || order?.get('regimen').get('fixedPrice')}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                }
              </div>
            }
            @if (order?.get('type') !== appConfig.Shared.Order.Type.REGIMEN && !!!order?.get('regimen')) {
              <div class="tw-rounded-2xl tw-p-4 tw-border tw-border-gray-200 tw-shadow-z1 tw-bg-white">
                <div class="tw-flex tw-justify-between tw-mb-4">
                  <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
                    @switch (true) {
                      @case (order.get('stage') === 'INITIAL') {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none" i18n="@@orderNotPlacedYet">
                    Order not placed yet
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none">
                          <span i18n="@@orderNumber">Order number</span><span>: {{'#'+order.get('orderNumber')}}</span>
                        </p>
                      }
                    }
                    @switch (true) {
                      @case (orderPaymentPendingStages.includes(order.get('stage'))) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      }
                      @case (!!ordersMap.get(order.id)?.expectedDeliveryDate?.to) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{ordersMap.get(order.id)?.expectedDeliveryDate?.to | date: 'd MMM'}}</span>
                        </p>
                      }
                      @case (!ordersMap.get(order.id)?.expectedDeliveryDate?.to && !orderDeliveredStages.includes(order.get('stage')) && !!order.get('deliverOnDate')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@expectedDelivery">Expected delivery</span><span>: {{ order.get('deliverOnDate') | date:'dd MM' }}</span>
                        </p>
                      }
                      @case (!ordersMap.get(order.id)?.expectedDeliveryDate?.to && orderDeliveredStages.includes(order.get('stage')) && !!order.get('deliveredOn')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          <span i18n="@@deliveredOn">Delivered on</span><span>: {{ order.get('deliveredOn') | date:'dd MMM yyyy' }}</span>
                        </p>
                      }
                      @case (orderCanceledStages.includes(order.get('stage')) && !order.get('canceledByUser')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@placeANewOrder">
                    Place a new order
                  </p>
                      }
                      @case (orderCanceledStages.includes(order.get('stage')) && !!order.get('canceledByUser')) {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400" i18n="@@userCancelled">
                    User cancelled
                  </p>
                      }
                      @default {
                        <p class="tw-font-body tw-text-200 tw-text-black tw-leading-none tw-text-gray-400">
                          -
                        </p>
                      }
                    }
                  </div>
                  @switch (true) {
                    @case (orderPaymentPendingStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-yellow-400 tw-bg-yellow-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@paymentPending">
                    Payment pending
                  </p>
                      </div>
                    }
                    @case (orderPlacedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@orderPlaced">
                    Order placed
                  </p>
                      </div>
                    }
                    @case (orderPackedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (ordersMap.get(order.id)?.shouldShowProductCancellationUI) {
                            <span>{{order.get('products').length}}/{{ordersMap.get(order.id).cancelledProducts.length + order.get('products').length}} </span>
                          }
                          <span i18n="@@packed">
                      Packed
                    </span>
                        </p>
                      </div>
                    }
                    @case (orderDispatchedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (ordersMap.get(order.id)?.shouldShowProductCancellationUI) {
                            <span>{{order.get('products').length}}/{{ordersMap.get(order.id).cancelledProducts.length + order.get('products').length}} </span>
                          }
                          <span i18n="@@shipped">Shipped</span>
                        </p>
                      </div>
                    }
                    @case (orderOutForDeliveryStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-red-400 tw-bg-red-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (ordersMap.get(order.id)?.shouldShowProductCancellationUI) {
                            <span>{{order.get('products').length}}/{{ordersMap.get(order.id).cancelledProducts.length + order.get('products').length}} </span>
                          }
                          <span i18n="@@outForDelivery">
                      Out For Delivery
                    </span>
                        </p>
                      </div>
                    }
                    @case (orderDeliveryFailedStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-border tw-border-green-400 tw-bg-green-100 tw-h-6 tw-flex tw-items-center tw-shrink-0 tw-px-3">
                        <p class="tw-font-body tw-text-200 tw-text-black">
                          @if (ordersMap.get(order.id)?.shouldShowProductCancellationUI) {
                            <span>{{order.get('products').length}}/{{ordersMap.get(order.id).cancelledProducts.length + order.get('products').length}} </span>
                          }
                          <span i18n="@@deliveryAttemptFailed">
                      Delivery attempt failed
                    </span>
                        </p>
                      </div>
                    }
                    @case (orderDeliveredStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        @if (ordersMap.get(order.id)?.shouldShowProductCancellationUI) {
                          <span class="tw-font-body tw-text-200 tw-text-black">{{order.get('products').length}}/{{ordersMap.get(order.id).cancelledProducts.length + order.get('products').length}} </span>
                        }
                        <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@delivered">Delivered</p>
                        <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                        </div>
                      </div>
                    }
                    @case (isCurrentOrderInRefundStages(order?.id) && (orderCanceledStages.includes(order.get('stage')) || order.get('stage') === appConfig.Shared.Order.Stage.REFUND_INITIATED)) {
                      <div>
                        @if (refundRelatedStageOrdersMap.get(order?.id)?.stage === appConfig.Shared.Order.Stage.REFUND_REQUESTED) {
                          <p class="tw-font-body tw-text-200 tw-text-gray-500">
                            Refund Requested
                          </p>
                        }
                        @if (refundRelatedStageOrdersMap.get(order?.id)?.stage === appConfig.Shared.Order.Stage.REFUND_INITIATED) {
                          <p class="tw-font-body tw-text-200 tw-text-gray-500">
                            Refund Initiated
                          </p>
                        }
                        @if (refundRelatedStageOrdersMap.get(order?.id)?.stage === appConfig.Shared.Order.Stage.REFUND_PROCESSED) {
                          <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                            <p class="tw-font-body tw-text-200 tw-text-black">
                              Refunded
                            </p>
                            <div class="tw-rounded-full tw-bg-green-400 tw-h-4">
                              <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'done'"></cs-icon>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @case (!isCurrentOrderInRefundStages(order?.id) && orderCanceledStages.includes(order.get('stage'))) {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto" i18n="@@canceled">
                    Cancelled
                  </p>
                        <div class="tw-rounded-full tw-bg-red-400 tw-h-4">
                          <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'close'"></cs-icon>
                        </div>
                      </div>
                    }
                    @default {
                      <div class="tw-rounded tw-flex tw-items-center tw-gap-1 tw-bg-gray-100 tw-border tw-border-gray-300 tw-px-1">
                        <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-min xs:tw-w-auto">
                          {{order.get('stage').replace('_', ' ') | titlecase}}
                        </p>
                      </div>
                    }
                  }
                </div>
                <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-2">
                  @if (!ordersMap.get(order.id)?.shouldHideProductDetails) {
                    @for (product of order.get('productInfo'); track product) {
                      <div class="tw-flex tw-items-center tw-gap-2">
                        <img class="tw-h-auto tw-max-h-10 tw-max-w-auto" [src]="product?.image" />
                        <p class="tw-font-body tw-text-300">{{product?.quantity}}</p>
                        <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-800" [iconName]='"close"'></cs-icon>
                        <p class="tw-font-body tw-text-300">{{product?.name}}</p>
                      </div>
                    }
                  }
                  @if (ordersMap.get(order.id)?.shouldShowProductCancellationUI) {
                    @for (product of ordersMap.get(order.id)?.cancelledProducts; track product) {
                      <div class="tw-flex tw-items-center tw-gap-2">
                        <img class="tw-h-auto tw-max-h-10 tw-max-w-auto" [src]="product?.imageUrl" alt="productImage"/>
                        <div class="tw-opacity-[0.4]">
                          <div class="tw-flex tw-items-center tw-gap-2">
                            <p class="tw-font-body tw-text-300">{{product?.quantity}}</p>
                            <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-800" [iconName]='"close"'></cs-icon>
                            <p class="tw-font-body tw-text-300">{{product?.title}}</p>
                          </div>
                          <p class="tw-text-100 tw-text-orange-500" i18n="@@removedByYourDoctor">Removed by your doctor</p>
                        </div>
                      </div>
                    }
                  }
                </div>
                @switch (true) {
                  @case (orderPaymentPendingStages.includes(order.get('stage'))) {
                    <div class="tw-flex tw-justify-between tw-items-center tw-mt-4">
                      <span class="tw-w-max tw-max-w-[90%] tw-bg-teal-600 tw-text-white tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold tw-relative tw-overflow-hidden tw-capitalize tw-py-2 tw-px-4" i18n="@@makePayment"> Make payment </span>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.get('stage')) && order.get('paymentType') === 'COD') {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <div class="tw-flex tw-flex-col">
                        <p class="tw-font-body tw-text-300">
                          <span class="tw-text-black" i18n="@@amountToBePaid">Amount to be paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                        </p>
                        @if (order.get('paymentType') === 'COD') {
                          <p class="tw-font-body tw-text-300">
                            (Cash on delivery)
                          </p>
                        }
                      </div>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (expectedDeliveryDateStages.includes(order.get('stage')) && order.get('paymentType') !== 'COD') {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @case (orderDeliveredStages.includes(order.get('stage'))) {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@amountPaid">Amount Paid</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                  @default {
                    <div class="tw-flex tw-justify-between tw-items-center">
                      <p class="tw-font-body tw-text-300">
                        <span class="tw-text-black" i18n="@@orderAmount">Order amount</span>:<span class="tw-font-body tw-font-bold tw-text-green-400"> ₹{{order.get('amount')}}</span>
                      </p>
                      <cs-icon class="tw-h-6 tw-w-6 tw-text-black" [iconName]='"chevron_right"'></cs-icon>
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
